import React from "react";
import Button from "@components/Button";

const SubmitInput = (props) => {
  if (props.valid) {
    return (
      <Button
        type="submit"
        title={props.label}
        size="normal"
        variant="primary"
        classesProp="js-trigger-save"
      />
    );
  }

  // Invalid component
  return null;
};

export default SubmitInput;
